import { render, staticRenderFns } from "./MetamaskCustomTokenWindow.vue?vue&type=template&id=9add3e6c&"
import script from "./MetamaskCustomTokenWindow.vue?vue&type=script&lang=js&"
export * from "./MetamaskCustomTokenWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports